{
  "$comment": "12 phase-1 Python services (docs/design/11 §3). Dev ports = 8000 + service number (compose.dev.yml publishes <service>:8000 on that host port). Override per service with env API_CLIENT_<NAME>_URL (e.g. API_CLIENT_CATALOG_URL=http://catalog:8000) or for all with API_CLIENT_BASE_URL_TEMPLATE=http://localhost/{service} when going through the gateway.",
  "defaults": {
    "host": "http://localhost",
    "openapiPath": "/openapi.json",
    "timeoutMs": 5000
  },
  "services": [
    { "name": "identity", "port": 8001, "schema": "identity" },
    { "name": "catalog", "port": 8002, "schema": "catalog" },
    { "name": "inventory", "port": 8003, "schema": "inventory" },
    { "name": "tax", "port": 8004, "schema": "tax" },
    { "name": "orders", "port": 8005, "schema": "orders" },
    { "name": "payments", "port": 8006, "schema": "payments" },
    { "name": "pos", "port": 8007, "schema": "pos" },
    { "name": "consignment", "port": 8008, "schema": "consignment" },
    { "name": "cms", "port": 8009, "schema": "cms" },
    { "name": "media", "port": 8010, "schema": "media" },
    { "name": "search", "port": 8011, "schema": "search" },
    { "name": "notification", "port": 8012, "schema": "notification" }
  ]
}
